import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button';
import { DialogTitle } from '@openx/components-core/lib/Dialog/DialogTitle/DialogTitle';
import { useTranslation } from 'react-i18next';

export type MarketUnionAppliedInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const MarketUnionAppliedInfoModal = ({ isOpen, onClose }: MarketUnionAppliedInfoModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle onClose={onClose}>{t('Grouping operator updated')}</DialogTitle>

      <DialogContent dividers>
        <Box>
          <Typography data-test="market-union-applied-modal-body">
            {t(
              "Segments from different regions, or sellable multipartner (Data Marketplace) segments on non-US markets, cannot be combined with AND between groups. We've updated the between-groups operator to OR (union)."
            )}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button data-test="market-union-applied-modal-ok" onClick={onClose} color="primary" variant="contained">
          {t('OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
